import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postTagAnAppointmentForBusiness } from "apis";
import { getAppointmentsQueryName } from "./get-appointments";

const usePostToggleTagForAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation(postTagAnAppointmentForBusiness, {
    onSuccess: () =>
      Promise.all([queryClient.invalidateQueries(getAppointmentsQueryName())]),
  });
};

export default usePostToggleTagForAppointment;
